import { css } from 'linaria';
import { createAdaptiveComponent } from './create-adaptive-component';

export const atMobile = css`
  display: none;

  @media (--only-mobile) {
    display: contents;
  }
`;

export const AtMobile = createAdaptiveComponent({
  displayName: 'AtMobile',
  ssrClassName: atMobile,
});
